import { supabase } from "@/integrations/supabase/client";

const FN_LOGIN = "cms-admin-login";
const FN_API = "cms-admin-api";

export function getAdminToken() {
  return localStorage.getItem("admin_token");
}

export function setAdminToken(token: string) {
  localStorage.setItem("admin_token", token);
}

export function clearAdminToken() {
  localStorage.removeItem("admin_token");
}

export async function adminLogin(username: string, password: string) {
  const { data, error } = await supabase.functions.invoke(FN_LOGIN, {
    body: { username, password },
  });
  if (error) throw error;
  return data as { token: string; expiresAt: string };
}

export async function adminApi<T = any>(payload: any): Promise<T> {
  const token = getAdminToken();
  if (!token) throw new Error("Not authenticated");
  const { data, error } = await supabase.functions.invoke(FN_API, {
    body: payload,
    headers: { Authorization: `Bearer ${token}` },
  });
  if (error) throw error;
  return data as T;
}

export async function uploadImage(file: File, folder = "uploads") {
  const token = getAdminToken();
  if (!token) throw new Error("Not authenticated");
  const formData = new FormData();
  formData.append("file", file);
  formData.append("folder", folder);
  const { data, error } = await supabase.functions.invoke(FN_API, {
    body: formData,
    headers: { Authorization: `Bearer ${token}` },
  });
  if (error) throw error;
  return data as { url: string; path: string };
}
